exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rows[data-v-4fdf6f37]{\n    color: black;\n}\n.tableHistory>thead>tr[data-v-4fdf6f37]{\n    background: #1C869A;\n    color: white;\n}\n", ""]);

// exports
